import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  url = "https://gestionedb.altervista.org/artDetails.php";
  data: any;

  baseUrl = 'https://ws.audioscrobbler.com/2.0/';
  apiKey = 'fe143212c0ca5fba498642110ab3d8b6';

  constructor(private http: HttpClient) { }

  getNews() {
    return this.http.get('https://gestionedb.altervista.org/artDetails.php');
  }
 
 getNotizia(art_id){
  let data: Observable<any> = this.http.get(this.url);
    return data
    .pipe(map((items) => {
      return items.find((item) =>
      (item.art_id == art_id));
    })
    );
  }

  getU2Artists() {
    const url = this.baseUrl + '?method=artist.gettopalbums&artist=u2&api_key=' + this.apiKey + '&format=json';
    return this.http.get(url).pipe(map((res: any) => {
    console.log('res', res);
    return res;
  }));
}

 getSimplemindsArtists() {
  const url = this.baseUrl + '?method=artist.gettopalbums&artist=simpleminds&api_key=' + this.apiKey + '&format=json';
  return this.http.get(url).pipe(map((res: any) => {
  console.log('res', res);
  return res;
}));
}

getDepechemodeArtists() {
  const url = this.baseUrl + '?method=artist.gettopalbums&artist=depechemode&api_key=' + this.apiKey + '&format=json';
  return this.http.get(url).pipe(map((res: any) => {
  console.log('res', res);
  return res;
}));
}

getCureArtists() {
  const url = this.baseUrl + '?method=artist.gettopalbums&artist=cure&api_key=' + this.apiKey + '&format=json';
  return this.http.get(url).pipe(map((res: any) => {
  console.log('res', res);
  return res;
}));
}
getLitfibaArtists() {
  const url = this.baseUrl + '?method=artist.gettopalbums&artist=litfiba&api_key=' + this.apiKey + '&format=json';
  return this.http.get(url).pipe(map((res: any) => {
  console.log('res', res);
  return res;
}));

}
getCultArtists() {
  const url = this.baseUrl + '?method=artist.gettopalbums&artist=thecult&api_key=' + this.apiKey + '&format=json';
  return this.http.get(url).pipe(map((res: any) => {
  console.log('res', res);
  return res;
}));

}
}